import React from "react"
import { Row } from "react-bootstrap"
import "../components/Jobs.scss"

export default function VideoCTA() {
  return (
    <Row>
      <div className="video-title">
        Like the movie better than the book? <br></br>
        Check out our Employee Testimonial about the position!
      </div>
    </Row>
  )
}
